import React from "react";

const PublicCoachingIcon = (props: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.2031 22.4062C6.57782 22.4062 2 17.8284 2 12.2031C2 6.57782 6.57782 2 12.2031 2V2.70827C6.96729 2.70827 2.70827 6.96729 2.70827 12.2031C2.70827 17.439 6.96729 21.698 12.2031 21.698C17.439 21.698 21.698 17.439 21.698 12.2031H22.4062C22.4062 17.8284 17.8284 22.4062 12.2031 22.4062Z"
        fill="currentColor"
      />
      <path
        d="M12.2615 9.74251C10.9659 9.74251 9.91211 8.54898 9.91211 7.08219C9.91211 5.61541 10.9659 4.42188 12.2615 4.42188C13.5571 4.42188 14.6109 5.61541 14.6109 7.08219C14.6109 8.54898 13.5571 9.74251 12.2615 9.74251ZM12.2615 4.86317C11.2109 4.86317 10.355 5.85725 10.355 7.08062C10.355 8.30399 11.2109 9.29808 12.2615 9.29808C13.3121 9.29808 14.168 8.30399 14.168 7.08062C14.168 5.85725 13.3121 4.86317 12.2615 4.86317Z"
        fill="currentColor"
      />
      <path
        d="M12.3664 19.236H9.41553L9.42653 13.7379L8.16232 15.3994L7.81055 15.1309L9.87253 12.4219L9.85997 18.7931H12.3664V19.236Z"
        fill="currentColor"
      />
      <path
        d="M7.74005 17.7358L6.42873 16.2942C5.93405 15.7492 5.87437 14.942 6.28268 14.3311L7.73848 12.1545C8.97284 10.3375 10.347 10.46 10.5511 10.4898H12.6681V10.9327H10.5119L10.4915 10.9296C10.4428 10.9217 9.23981 10.7333 8.10439 12.4026L6.65017 14.5777C6.35492 15.0206 6.39732 15.6032 6.75538 15.9974L8.0667 17.439L7.73848 17.7374L7.74005 17.7358Z"
        fill="currentColor"
      />
      <path
        d="M15.318 19.236H12.3672V18.7931H14.8736L14.861 12.4219L16.923 15.1309L16.5697 15.3994L15.307 13.7379L15.318 19.236Z"
        fill="currentColor"
      />
      <path
        d="M16.9924 17.7351L16.6641 17.4367L17.9755 15.995C18.3335 15.6009 18.3759 15.0182 18.0807 14.5754L16.6249 12.3987C15.48 10.7137 14.2504 10.9241 14.2394 10.9257L14.219 10.9288H12.4727V10.486H14.1797C14.3839 10.4561 15.758 10.3336 16.9924 12.149L18.4482 14.3272C18.8565 14.9381 18.7968 15.7469 18.3021 16.2903L16.9908 17.7319L16.9924 17.7351Z"
        fill="currentColor"
      />
      <path
        d="M12.7778 16.3211L11.0676 15.7635L11.7837 13.9732L10.4473 10.7806L10.8556 10.6094L12.1873 13.7911L13.6211 14.2402L12.7778 16.3195V16.3211ZM11.6549 15.4887L12.5234 15.7714L13.0322 14.5198L12.1543 14.2449L11.6565 15.4887H11.6549Z"
        fill="currentColor"
      />
      <path
        d="M13.4409 11.5867L11.8428 13.8438L12.2042 14.0997L13.8023 11.8426L13.4409 11.5867Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PublicCoachingIcon;
